// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".document{min-width:110px;background:#fff;display:flex;align-items:center;justify-content:center;flex:1;position:relative}\n", ""]);
// Exports
module.exports = exports;
